import { Draft } from '@reduxjs/toolkit';
import { PrivateAssetResult } from '@ff-os/shared-utils/types/private-assets/PrivateAssetResult';
import { Size } from '@ff-os/shared-utils/types/Size';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import cuid from 'cuid';

export const saveExternalUpload = (
    input: Draft<GiftJson.Input<PhotoVariableInput>>,
    result: PrivateAssetResult<Size>
) => {
    input.value = {
        ...input.value,
        cuid: cuid(),
        fileName: result.fileName,
        imageWidth: result.meta.width,
        imageHeight: result.meta.height,
        status: 'saved',
        processed: true,
        assetId: result.assetId,
        assetSource: 'private',

        cropBox: {
            x: 0,
            y: 0,
            width: result.meta.width!,
            height: result.meta.height!
        }
    };
};